module.exports = __webpack_public_path__ + "static/media/Account_Active.d6c8128f.svg";